import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import { BestPluckerPerfromanceSchemaObject } from "../BestPluckerPerfromanceSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './CreatePdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@mui/material/Typography';
import _ from 'lodash';


const screenCode = "VIEWBESTPLUCKERPERFORMANCEREPORT";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function ViewBestPluckerPerfromance(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [fields, setFields] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [excelData, setExcelData] = useState([]);
    const [totalData, setTotalData] = useState([]);
    const [viewBestPluckerPerfromance, setViewBestPluckerPerfromance] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        fromDate: "",
        toDate: "",
        pluckingType: "All"

    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        fromDate: "",
        toDate: "",
        pluckingType: "0"
    })
    const [csvData, setCsvData] = useState([]);

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);


    const contentRowNames = ["estateName", "divisionName", "employeeName", "employeeID", "days", "qty", "perDayAverage"]
    const csvHeaders = [
        { label: "Division Name", value: "division" },
        { label: "Employee Reg No", value: "employeeID" },
        { label: "Employee Name", value: "employeeName" },
        { label: "No of Days", value: "days" },
        { label: "Quantity (Kg)", value: "qty" },
        { label: "Per Day Avg (%)", value: "perDayAverage" }
    ];

    const [reportData, setReportData] = useState([]);
    const [newReportData, setNewReportData] = useState([]);
    const [keys, setKeys] = useState([]);

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        trackPromise(getPermissions());
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [viewBestPluckerPerfromance.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
        )
    }, [viewBestPluckerPerfromance.estateID])


    function clearTable() {
        setIsTableHide(true);
        setIsReportButtonsEnabled(false);
        setReportData([]);
        setViewBestPluckerPerfromance({
            groupID: "0",
            estateID: "0",
            divisionID: "0",
            fromDate: new Date(),
            toDate: new Date(),
            pluckingType: "All"
        })
    }

    function handleGroupChange(target) {
        validateInputs(target);
        setViewBestPluckerPerfromance({
            ...viewBestPluckerPerfromance,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            pluckingType: "All"
        });
    }

    function handleEstateChange(target) {
        setViewBestPluckerPerfromance({
            ...viewBestPluckerPerfromance,
            estateID: target.value,
            divisionID: "0"
        });
    }

    function handleDivisionChange(target) {
        setViewBestPluckerPerfromance({
            ...viewBestPluckerPerfromance,
            divisionID: target.value
        });
    }

    function handleSearchFromDateChange(target) {
        validateInputs(target);
        setViewBestPluckerPerfromance({
            ...viewBestPluckerPerfromance,
            fromDate: target.value
        });
    }

    function handleSearchToDateChange(target) {
        validateInputs(target);
        setViewBestPluckerPerfromance({
            ...viewBestPluckerPerfromance,
            toDate: target.value
        });
    }

    function handlePluckingTypeChange(target) {
        setViewBestPluckerPerfromance({
            ...viewBestPluckerPerfromance,
            pluckingType: target.value
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, BestPluckerPerfromanceSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];
        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWBESTPLUCKERPERFORMANCEREPORT');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromToken();
        setViewBestPluckerPerfromance({
            ...viewBestPluckerPerfromance,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(viewBestPluckerPerfromance.groupID);
        setEstates(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(viewBestPluckerPerfromance.estateID);
        setDivisions(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }



    async function getdata(e) {
        e.preventDefault();
        setIsTableHide(true);
        setButtonHide(true);
        getSelectedDropdownValuesForReport(viewBestPluckerPerfromance);
        setIsTableHide(true);

        var model = {
            groupID: parseInt(viewBestPluckerPerfromance.groupID),
            estateID: parseInt(viewBestPluckerPerfromance.estateID),
            collectionPointID: parseInt(viewBestPluckerPerfromance.divisionID),
            fromDate: viewBestPluckerPerfromance.fromDate,
            toDate: viewBestPluckerPerfromance.toDate,
            pluckingType: viewBestPluckerPerfromance.pluckingType
        }
        const result = await services.BestPluckerPerfromanceReportData(model);

        result.forEach(x => {
            x.groupedData.sort((a, b) => (a.qty > b.qty) ? 1 : -1)
        });

        result.forEach(x => {
            x.groupedData.forEach(y => {
                y.perDayAverage = (y.qty / y.days);
            })
        })
        setReportData(result);

        if (result.length > 0) {
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }
        setButtonHide(false);
        setIsReportButtonsEnabled();
        setCsvData(newReportData)

        var copyOfRecords = _.cloneDeep(result);

        let excelArray = [];
        copyOfRecords.forEach(x => {
            x.groupedData.forEach(y => {
                excelArray.push(y)
            })
        })
        setExcelData(excelArray);


        let totalArray = [];
        copyOfRecords.forEach(x => {
            let dataLength = x.groupedData.length;
            for (let i = 0; i < x.groupedData.length; i++) {
                if (i === (dataLength - 1)) {
                    totalArray.push(x.groupedData[i]);
                }
            }

        });
        setTotalData(totalArray);
    }

    function createFile() {
        var settings = {
            sheetName: ' BPP report',
            fileName: 'BPP Report',
            writeOptions: {}
        }

        var copyOfCsv = _.cloneDeep(excelData);
        copyOfCsv.forEach(x => {
            x.qty = parseFloat(x.qty).toFixed(2)
            x.perDayAverage = parseFloat(x.perDayAverage).toFixed(2)
        });
        var newRow1 = {
            division: "Group :" + groups[viewBestPluckerPerfromance.groupID],
            employeeID: "Estate : " + estates[viewBestPluckerPerfromance.estateID],
            employeeName: viewBestPluckerPerfromance.divisionID == "0" ? "Division : All Division" : "Division : " + divisions[viewBestPluckerPerfromance.divisionID],
            days: "From : " + viewBestPluckerPerfromance.fromDate,
            qty: "To : " + viewBestPluckerPerfromance.toDate
        }
        copyOfCsv.push({}, {}, newRow1)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            field: fields[searchForm.fieldID],
            fromDate: searchForm.fromDate,
            toDate: searchForm.toDate
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Best Plucker Performance Analysis Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={viewBestPluckerPerfromance.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={viewBestPluckerPerfromance.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Division</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={viewBestPluckerPerfromance.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">-- Select Division --</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="pluckingType">Harvesting Job *</InputLabel>
                                        <Select fullWidth
                                            id="pluckingType"
                                            name="pluckingType"
                                            value={viewBestPluckerPerfromance.pluckingType}
                                            onChange={(e) => handlePluckingTypeChange(e.target)}>
                                            <MenuItem value="All">--Select Harvesting Job--</MenuItem>
                                            <MenuItem value="GENERAL">GENERAL</MenuItem>
                                            <MenuItem value="KILO">KILO</MenuItem>
                                            <MenuItem value="RSM">RSM</MenuItem>
                                        </Select>
                                        {errors["pluckingType"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["pluckingType"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onChange={(e) => handleSearchFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onChange={(e) => handleSearchToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(getdata(e))}
                                    />
                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={clearTable}
                                    />
                                </div>
                            </form>
                            {isTableHide ? null :
                                <div>
                                    <br />
                                    <br />

                                    <TableContainer component={Paper}>
                                        {reportData.map((row, i) => (
                                            <>
                                                <Table className={classes.table} aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow >
                                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Division Name</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Reg No</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Name</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: "bold" }}>No of Days</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Quantity (Kg)</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Per Day Avg (%)</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {row.groupedData.map((rows, i) => (
                                                            <TableRow key={i} >
                                                                <TableCell component="th" style={{ backgroundColor: (row.groupedData.length - 1 === i) ? '#a5d6a7' : null }} scope="row" align="center"> {rows.division}</TableCell>
                                                                <TableCell component="th" style={{ backgroundColor: (row.groupedData.length - 1 === i) ? '#a5d6a7' : null }} scope="row" align="center"> {rows.employeeID}</TableCell>
                                                                <TableCell component="th" style={{ backgroundColor: (row.groupedData.length - 1 === i) ? '#a5d6a7' : null }} scope="row" align="center"> {rows.employeeName}</TableCell>
                                                                <TableCell component="th" style={{ backgroundColor: (row.groupedData.length - 1 === i) ? '#a5d6a7' : null }} scope="row" align="center"> {rows.days}</TableCell>
                                                                <TableCell component="th" style={{ backgroundColor: (row.groupedData.length - 1 === i) ? '#a5d6a7' : null }} scope="row" align="center"> {parseFloat(rows.qty).toFixed(2)}</TableCell>
                                                                <TableCell component="th" style={{ backgroundColor: (row.groupedData.length - 1 === i) ? '#a5d6a7' : null }} scope="row" align="center"> {parseFloat(rows.perDayAverage).toFixed(2)}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                        <br />
                                                    </TableBody>
                                                </Table>
                                                <br />
                                                {/* <TablePagination
                                                    component="div"
                                                    count={reportData.length}
                                                    onChangePage={handlePageChange}
                                                    onChangeRowsPerPage={handleLimitChange}
                                                    page={page}
                                                    rowsPerPage={limit}
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                /> */}
                                            </>
                                        ))
                                        }
                                    </TableContainer>
                                    <br /><br />
                                    <Typography variant="body1" gutterBottom sx={{ color: "#2e7d32", fontWeight: "bold", textAlign: "center" }}>
                                        Overall Plantation - Top Pluckers
                                    </Typography>
                                    <TableContainer component={Paper}>
                                        <>
                                            <Table className={classes.table} aria-label="simple table">
                                                <TableHead>
                                                    <TableRow style={{ backgroundColor: '#a5d6a7' }}>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Division Name</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Reg NO</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Name</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>No of Days</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Quantity (Kg)</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Per Day Avg (%)</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {totalData.map((rows, i) => (
                                                        <TableRow key={i} style={{ backgroundColor: '#a5d6a7' }} >
                                                            <TableCell component="th" scope="row" align="center"> {rows.division}</TableCell>
                                                            <TableCell component="th" scope="row" align="center"> {rows.employeeID}</TableCell>
                                                            <TableCell component="th" scope="row" align="center"> {rows.employeeName}</TableCell>
                                                            <TableCell component="th" scope="row" align="center"> {rows.days}</TableCell>
                                                            <TableCell component="th" scope="row" align="center"> {parseFloat(rows.qty).toFixed(2)}</TableCell>
                                                            <TableCell component="th" scope="row" align="center"> {parseFloat(rows.perDayAverage).toFixed(2)}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                            {/* <TablePagination
                                                component="div"
                                                count={reportData.length}
                                                onChangePage={handlePageChange}
                                                onChangeRowsPerPage={handleLimitChange}
                                                page={page}
                                                rowsPerPage={limit}
                                                rowsPerPageOptions={[5, 10, 25]}
                                            /> */}
                                        </>
                                    </TableContainer>
                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                        <ReactToPrint
                                            documentTitle={"Best Plucker Performance Analysis Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"
                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} keys={keys} topData={totalData} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment >
    );
}
